import _ from "lodash";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import I18nHOC from "UIComponents/I18nHOC";
import classes from "./SelectKCModal.scss";
import { Modal, Button } from "@toddle-edu/ds-web";
import { TickCircleFilled } from "@toddle-edu/ds-icons";
import { onEnterOrSpaceKeyDown } from "Utils";
class SelectKCModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selctedKeyConcepts: [],
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { selectedKeyConcepts: oldSelectedKeyConcepts } = prevState;
    const { selectedKeyConcepts } = this.state;
    const { updateValueLocally } = this.props;
    if (selectedKeyConcepts != oldSelectedKeyConcepts) {
      if (updateValueLocally) {
        updateValueLocally(selectedKeyConcepts);
      }
    }
  };

  UNSAFE_componentWillMount = () => {
    this.setState({
      selectedKeyConcepts: this.props.selectedKeyConcepts
        ? this.props.selectedKeyConcepts
        : [],
    });
  };

  onAddKC = value => {
    const selectedKeyConcepts = [...this.state.selectedKeyConcepts];

    const index = _.indexOf(selectedKeyConcepts, value);

    if (index != -1) {
      selectedKeyConcepts.splice(index, 1);
    } else {
      selectedKeyConcepts.push(value);
    }
    this.setState({ selectedKeyConcepts });
  };

  onCancelClick = () => {
    this.setState({ selctedKeyConcepts: [] });
    this.props.onCancelClick();
  };

  onAddClick = () => {
    const selectedKeyConcepts = [...this.state.selectedKeyConcepts];
    const storeKeyConcepts = this.props.selectedKeyConcepts;
    // let newKeyConcepts = [];
    // _.map(selectedKeyConcepts, selectedKC => {
    //   if (!this.checkIfKCExistInStore(selectedKC)) {
    //     let newKCStoreObj = {
    //       value: selectedKC,
    //       questions: _.reduce(
    //         this.props.questions,
    //         (prevResult, quesObj, index) => {
    //           prevResult[quesObj.value] = "";
    //           return prevResult;
    //         },
    //         {}
    //       )
    //     };
    //     newKeyConcepts.push(newKCStoreObj);
    //   } else {
    //     const storeObj = _.find(storeKeyConcepts, storeKCObj => {
    //       return storeKCObj.value == selectedKC;
    //     });
    //     newKeyConcepts.push(storeObj);
    //   }
    // });
    this.props.updateInputField({ [this.props.name]: selectedKeyConcepts });
    this.props.onCancelClick();
    this.setState({ selctedKeyConcepts: [] });
  };

  checkIfKCExistInStore = kc => {
    return _.indexOf(this.props.selectedKeyConcepts, kc) != -1;
  };

  getKCList = data => {
    const KCList = _.map(data, (itemObject, index) => {
      return (
        <KCItem
          item={itemObject}
          selectedKeyConcepts={this.state.selectedKeyConcepts}
          key={index}
          value={itemObject.value}
          onAddKC={this.onAddKC}
        />
      );
    });

    return KCList;
  };

  render() {
    const KCListComponent = this.getKCList(this.props.keyConcepts);
    const { t, isEdit, testId } = this.props;
    return (
      <Modal
        hasOverlay={true}
        isOpen={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        width={"680px"}
        height={"640x"}
        onClose={this.onCancelClick}
      >
        <Modal.Header
          isClosable={true}
          title={this.props.addLabel}
          testId={testId}
        />
        <Modal.Body isScrollable={true}>
          <div className={classes.modalBody}>
            <div className={classes.fieldComp}>{KCListComponent}</div>
          </div>
        </Modal.Body>
        <Modal.Footer hasSeparator={true}>
          <div className={classes.modalFooter}>
            <div className={classes.cancelButton}>
              <Button
                variant="neutral"
                type="outlined"
                dsVersion="2.0"
                onClick={this.onCancelClick}
                testId={`${testId}-cancel`}
              >
                {t("common:cancel")}
              </Button>
            </div>

            <Button
              type="fill"
              onClick={this.onAddClick}
              variant="progressive"
              testId={`${testId}-${isEdit ? "update" : "add"}`}
              dsVersion="2.0"
              shortcut={{
                code: "Enter",
                shiftKey: true,
              }}
            >
              {this.props.isEdit ? t("common:update") : t("common:add")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const KCItem = ({ item, value, selectedKeyConcepts, onAddKC, index }) => {
  const isKCSelected = (selectedKeyConcepts, item) => {
    return _.includes(selectedKeyConcepts, item.value);
  };

  const onAddKCCallBack = () => {
    onAddKC(value);
  };
  return (
    <div
      key={index}
      className={
        isKCSelected(selectedKeyConcepts, item)
          ? classes.focusItemCompActive
          : classes.focusItemComp
      }
      onClick={onAddKCCallBack}
      tabIndex={0}
      onKeyDown={e => {
        onEnterOrSpaceKeyDown(e, onAddKCCallBack);
      }}
      data-test-id={`unitPlans-selectKC-${item.label}-card`}
    >
      <div className={classes.tickAndHelperComp}>
        {isKCSelected(selectedKeyConcepts, item) ? (
          <div className={classes.selectedTickComp}>
            <TickCircleFilled size="x-small" variant="on" />
          </div>
        ) : (
          <div className={classes.selectedTickComp} />
        )}
      </div>
      <div
        className={
          isKCSelected(selectedKeyConcepts, item)
            ? classes.titleTextSelected
            : classes.titleText
        }
      >
        {item.label}
      </div>
      {item.subText && (
        <div
          className={
            isKCSelected(selectedKeyConcepts, item)
              ? classes.subTextSelected
              : classes.subText
          }
        >
          {item.subText}
        </div>
      )}
    </div>
  );
};

SelectKCModal.propTypes = {
  updateInputField: PropTypes.func,
  onCancelClick: PropTypes.func,
  keyConcepts: PropTypes.array,
  selectedKeyConcepts: PropTypes.array,
  name: PropTypes.string,
  isEdit: PropTypes.bool,
};

SelectKCModal.defaultProps = {
  isEdit: false,
};

export default I18nHOC({ resource: "common" })(SelectKCModal);
